export const environment = {
  production: true,

  navigation: {
    title: 'DEKRA T.C',
    copyright: 'DEKRA Testing and Certification, S.A.U.',
    favIcon: 'assets/img/iconos/dekra_logo_favicon.ico'
  },
  login: {
    background: 'assets/img/login/DEKRA_COR_WallPaper_00_SafeWorld_16_9.jpg',
    header: 'assets/img/login/DEKRA_cabecera_login.png'
  },
  base: {
    url: ''
  },
  gatewayEndpoints: {
    cmdb: '/ServiberProREST',
    auth: '/api/authentication',
    autocheck: '/autochecking',
    report: '/report',
    facturacion: '/FacturacionRest'
  },
  issuesRefreshInterval: '',
  manual: 'MANUAL DE USUARIO.pdf',
  samlLoginUrl: 'https://autoservicio-ggcc.orange.es/api/authentication/saml/login',
  samlCallbackUrl: 'https://autoservicio-ggcc.orange.es/api/authentication/callback'
};
